@switch (navItem.type) {
    @case ('router') {
        @if (navItem.disabled) {
            <mat-list-item disabled [matTooltip]="isExpanded ? '' : navItem.label" matTooltipPosition="after">
                <mat-icon
                    aria-hidden="false"
                    matListItemIcon
                    [matBadge]="navItem.badge"
                    matBadgeColor="warn"
                    matBadgeSize="small"
                    class="select-none"
                    [fontSet]="navItem.icon.fontSet || 'material-symbols'"
                >
                    {{ navItem.icon.name }}
                </mat-icon>
                <h4 matListItemTitle class="nav-item-title ml-[2px] overflow-hidden" mat-line>{{ navItem.label }}</h4>
            </mat-list-item>
        } @else {
            <mat-list-item
                routerLink="{{ navItem.routerLink }}"
                routerLinkActive
                [state]="{ navigatedBy: EventTrackerNavigationReasons.NavigationSidebarItem }"
                #rla="routerLinkActive"
                [routerLinkActiveOptions]="{ matrixParams: 'ignored', queryParams: 'subset', paths: 'subset', fragment: 'ignored' }"
                [activated]="rla.isActive"
                [disableRipple]="rla.isActive"
                [matTooltip]="isExpanded ? '' : navItem.label"
                matTooltipPosition="after"
                (click)="!rla.isActive && this.closeMenu.emit()"
            >
                <mat-icon
                    aria-hidden="false"
                    matListItemIcon
                    [matBadge]="navItem.badge"
                    matBadgeColor="warn"
                    matBadgeSize="small"
                    class="select-none"
                    [fontSet]="navItem.icon.fontSet || 'material-icons'"
                >
                    {{ navItem.icon.name }}
                </mat-icon>
                <h4 matListItemTitle class="nav-item-title ml-[2px] overflow-hidden" mat-line>{{ navItem.label }}</h4>
            </mat-list-item>
        }
    }
    @case ('action') {
        <mat-list-item
            [matTooltip]="isExpanded ? '' : navItem.label"
            matTooltipPosition="after"
            (click)="executeAction(navItem); closeMenu.emit()"
        >
            <mat-icon matListItemIcon class="select-none" [fontSet]="navItem.icon.fontSet || 'material-symbols-rounded'">
                {{ navItem.icon.name }}
            </mat-icon>
            <h4 matListItemTitle class="nav-item-title ml-[2px] overflow-hidden" mat-line>{{ navItem.label }}</h4>
        </mat-list-item>
    }
    @case ('href') {
        <a href="{{ navItem.href || '' }}" target="{{ navItem.target || '_blank' }}" rel="{{ navItem.rel || 'noreferrer' }}">
            <mat-list-item [matTooltip]="isExpanded ? '' : navItem.label" matTooltipPosition="after" (click)="this.closeMenu.emit()">
                <mat-icon matListItemIcon class="select-none" [fontSet]="navItem.icon.fontSet || 'material-symbols'">
                    {{ navItem.icon.name }}
                </mat-icon>
                <h4 matListItemTitle class="ml-[2px] overflow-hidden">{{ navItem.label }}</h4>
            </mat-list-item>
        </a>
    }
}
